import { Chip } from "@mui/material";

function normalize(val) {
  return String(val || "")
    .trim()
    .toLowerCase()
    .replaceAll("ı", "i")
    .replaceAll("ş", "s")
    .replaceAll("ğ", "g")
    .replaceAll("ü", "u")
    .replaceAll("ö", "o")
    .replaceAll("ç", "c");
}

const WORK_ORDER_STATUS_LABELS = {
  open: "açık",
  in_progress: "üretimde",
  completed: "bitti",
  cancelled: "iptal",
};

function getBadgeStyle(value) {
  const v = normalize(value);

  // Warm/cool palette; keep contrast readable on light background.
  const map = {
    // İş emri durumları
    open: { bg: "rgba(234, 179, 8, 0.25)", fg: "#854D0E" },
    in_progress: { bg: "rgba(34, 197, 94, 0.2)", fg: "#166534" },
    completed: { bg: "rgba(239, 68, 68, 0.2)", fg: "#991B1B" },
    cancelled: { bg: "rgba(148, 163, 184, 0.25)", fg: "#334155" },
    // Operasyon durumları
    beklemede: { bg: "rgba(148, 163, 184, 0.25)", fg: "#334155" },
    baskida: { bg: "rgba(14, 165, 233, 0.18)", fg: "#075985" },
    kesimde: { bg: "rgba(245, 158, 11, 0.18)", fg: "#92400E" },
    ayiklamada: { bg: "rgba(34, 197, 94, 0.16)", fg: "#166534" },
    formlamada: { bg: "rgba(168, 85, 247, 0.14)", fg: "#6B21A8" },
    shrink: { bg: "rgba(99, 102, 241, 0.14)", fg: "#3730A3" },
    shrinkte: { bg: "rgba(99, 102, 241, 0.14)", fg: "#3730A3" },
    tamamlandi: { bg: "rgba(34, 197, 94, 0.18)", fg: "#166534" },
    problemli: { bg: "rgba(239, 68, 68, 0.18)", fg: "#991B1B" },
  };

  return map[v] || { bg: "rgba(15, 23, 42, 0.06)", fg: "#334155" };
}

export default function StatusBadge({ value, label, size = "small", useWorkOrderLabels = false }) {
  const { bg, fg } = getBadgeStyle(value ?? label);
  const rawText = label ?? (value ? String(value) : "—");
  const mappedText = useWorkOrderLabels && value ? (WORK_ORDER_STATUS_LABELS[String(value).toLowerCase()] ?? rawText) : rawText;
  const text = useWorkOrderLabels && mappedText ? String(mappedText).toLocaleUpperCase("tr-TR") : mappedText;

  return (
    <Chip
      size={size}
      label={text}
      sx={{
        borderRadius: 999,
        bgcolor: bg,
        color: fg,
        fontWeight: 700,
        border: "1px solid rgba(15, 23, 42, 0.08)",
      }}
    />
  );
}
